import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { NavCta, NavLinkItem } from '../../../types/navigation'

const navLinks: NavLinkItem[] = [
	{ name: 'Individuals', to: '/individuals' },
	{ name: 'helfy® Business', to: '/business' },
	{ name: 'helfy® Clinic', to: '/clinic' },
	{ name: 'About us', to: '/about-us' }
]

// NOTE: each page carries its own call to action, the home page has none
const pagesCTAs: Record<string, NavCta> = {
	'/individuals': { text: 'Get tested', href: '#packages' },
	'/business': { text: 'Book a workshop', href: '#workshop' },
	'/clinic': { text: 'Join waiting list', href: '#waiting-list' }
}

const useNavBar = () => {
	const { pathname } = useLocation()
	const [showNav, setShowNav] = useState(false)

	const currentPageCTA = pagesCTAs[pathname]

	// NOTE: closes the phone menu on navigation
	useEffect(() => setShowNav(false), [pathname])

	// NOTE: locks the page scroll while the phone menu is open
	useEffect(() => {
		document.body.style.overflow = showNav ? 'hidden' : ''

		return () => {
			document.body.style.overflow = ''
		}
	}, [showNav])

	return { navLinks, currentPageCTA, showNav, setShowNav }
}

export default useNavBar
